import React from "react";
import logoMobile from "../../../assets/logoa2.png";
import { useEffect } from "react";
import {
  FaUsers,
  FaChartBar,
  FaUserPlus,
  FaClipboardList,
  FaBookOpen,
  FaUser,
  FaHandsHelping,
  FaCog,
} from "react-icons/fa";
import {MdAddHome } from "react-icons/md";
import { SiDatabricks } from "react-icons/si";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { adminContext } from "../../../context/admincontext";
const Menu = () => {
  const { toggel, setToggel } = useContext(adminContext);

  useEffect(() => {
    if (window.innerWidth >= 992) {
      setToggel(true);
    } else {
      setToggel(false);
    }
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setToggel(true);
      } else {
        setToggel(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", handleResize);
    };
  }, []);

  const clicItem = () => {
    if (window.innerWidth <= 992) {
      setToggel(false);
    }
  };

  return (
    <div className="" >
      <div className={`adminpanel-menu ${toggel ? "admin-show-menu" : ""}`}>
        <img alt="" src={logoMobile} className="user-menu-logo" />
        <p className="expert-menu-label">پنل ادمین</p>
        <div className="mt-4">
          <ul className="userpanel-menu-list">
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/admin/experts"
            >
              <li className="mb-4">
                <FaUser />
                &nbsp;&nbsp; کارشناسان
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/admin/users"
            >
              <li className="mb-4">
                <FaUsers />
                &nbsp;&nbsp; کاربران
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/admin/statistics"
            >
              <li className="mb-4">
                <FaChartBar /> &nbsp;&nbsp;آمار
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/admin/new-expert"
            >
              <li className="mb-4">
                <FaUserPlus /> &nbsp;&nbsp;ثبت کارشناس
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/admin/requests"
            >
              <li className="mb-4">
                <FaClipboardList /> &nbsp;&nbsp;درخواست ها/کارشناسی ها
              </li>
            </Link>
            <Link
            onClick={() => clicItem()}
            className="userpanel-menu-list-item"
            to="/admin/add-new-realestate"
          >
            <li className="mb-4">
              <MdAddHome /> &nbsp;&nbsp;اضافه کردن املاک
            </li>
          </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/admin/reports"
            >
              <li className="mb-4">
                <FaBookOpen /> &nbsp;&nbsp;گزارشات
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/admin/support"
            >
              <li className="mb-4">
                <FaHandsHelping /> &nbsp;&nbsp;پشتیبانی
              </li>
            </Link>
            <Link
              onClick={() => clicItem()}
              className="userpanel-menu-list-item"
              to="/admin/setting"
            >
              <li className="mb-4">
                <FaCog /> &nbsp;&nbsp;تنظیمات سیستم
              </li>
            </Link>
            <Link
            className="userpanel-menu-list-item"
            to="/"
            onClick={() => {
              localStorage.removeItem("token");
            }}
          >
            <li className="mb-4">
            <div className=' request-Previous-btn-box mt-2 '>
          <button className='btn request-Previous-btn ' type='button'>خروج</button>
          </div>
            </li>
          </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Menu;
